import { runDemo } from "../shared/demoRunner";
import { createSPSCollisionsTestScene } from "./scene";

runDemo({ createScene: createSPSCollisionsTestScene });
